import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function howEvidence () {
	document.querySelectorAll('.how-evidence').forEach((section) => {
		const bar = section.querySelector('.nav-cover-bar');
		if (! bar) return;
		ScrollTrigger.create({
			trigger: section,
			start: 'top top',
			end: 'bottom top',
			onToggle: (self) => bar.classList.toggle('is-fixed', self.isActive),
		});
	});
	ScrollTrigger.refresh();
}
